var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#3800AE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7005 15.0804L16.3985 11.3824C15.7763 11.1226 15.2113 10.7431 14.7355 10.2654C14.2576 9.78947 13.8779 9.22425 13.618 8.60186L9.92 12.2999C9.6315 12.5884 9.487 12.7329 9.363 12.8919C9.21655 13.0795 9.09098 13.2825 8.9885 13.4974C8.902 13.6794 8.8375 13.8734 8.7085 14.2604L8.0275 16.3019C7.99615 16.3953 7.9915 16.4957 8.01407 16.5917C8.03663 16.6876 8.08552 16.7754 8.15523 16.8451C8.22495 16.9148 8.31272 16.9637 8.40869 16.9863C8.50466 17.0089 8.60502 17.0042 8.6985 16.9729L10.74 16.2919C11.1275 16.1629 11.321 16.0984 11.503 16.0119C11.718 15.9094 11.921 15.7839 12.1085 15.6374C12.2675 15.5134 12.412 15.3689 12.7005 15.0804ZM17.4245 10.3564C17.7932 9.98764 18.0004 9.48756 18.0004 8.96611C18.0004 8.44467 17.7932 7.94458 17.4245 7.57586C17.0558 7.20714 16.5557 7 16.0342 7C15.5128 7 15.0127 7.20714 14.644 7.57586L14.2005 8.01936L14.2195 8.07486C14.4381 8.70022 14.7957 9.26781 15.2655 9.73486C15.7465 10.2187 16.334 10.5834 16.981 10.7999L17.4245 10.3564Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9ee55186bf9de545d37d66bbaaf62567.svg";
export { ForwardRef as ReactComponent };